import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
  OnInit
} from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { Subject, takeUntil } from 'rxjs'
import { FoodItemModel } from 'src/app/models/food-item.model'
import { AyBService } from 'src/app/services/api/ayb.service'
import { stringSimilarity } from 'string-similarity-js'
import Swal from 'sweetalert2'
import { FormCocinaService } from '../../../services/forms/form-cocina.service'

interface DialogSkusData {
  id: string
  peso: number
  title: string
  estado: number
  listaSKU: FoodItemModel[]
  estadoSKU: string | null
  categoria: string
  stockReal: number | null
  codigoInsumo: string
  nombreInsumo: string
  stockTeorico: number | null
  unidadMedida: string
}

@Component({
  selector: 'app-dialog-skus',
  templateUrl: './dialog-skus.component.html',
  styleUrls: ['./dialog-skus.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogSkusComponent implements OnInit, OnDestroy {
  private _unsubscribeOnDestroy$ = new Subject<boolean>()

  selectedCategoria: string | null = null
  arrayCategoria = [
    'ABA',
    'BEB',
    'CAR',
    'CON',
    'EMB',
    'FIA',
    'FRU',
    'INS',
    'LAC',
    'LIM',
    'OTR',
    'PAN',
    'PLA',
    'POS',
    'SNA',
    'VER'
  ]
  arrayUM = ['KG', 'UN', 'LT', 'GR', 'ML', 'MT']
  arrayEstados = ['ACTIVO', 'DESACTIVADO']
  coincidencias: any[] = []

  skuForm
  constructor (
    private readonly formService: FormCocinaService,
    private readonly alimentosService: AyBService,
    public dialogRef: MatDialogRef<DialogSkusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogSkusData
  ) {
    this.skuForm = this.formService.getSKUForm()
  }
  ngOnInit (): void {
    console.log({
      data: this.data
    })

    this.skuForm.get(['nombreInsumo'])?.setValue(this.data.nombreInsumo)
    this.skuForm.get(['categoria'])?.setValue(this.data.categoria)
    this.skuForm.get(['peso'])?.setValue(this.data.peso)
    this.skuForm.get(['unidadMedida'])?.setValue(this.data.unidadMedida)
    this.skuForm.get(['estado'])?.setValue(this.data.estadoSKU)
    this.skuForm.get(['stockTeorico'])?.setValue(this.data.stockTeorico)
    this.skuForm.get(['stock'])?.setValue(this.data.stockReal)

    this.skuForm.get(['stockTeorico'])?.disable({
      onlySelf: true,
      emitEvent: false
    })

    if (this.data.estado === 1) {
      this.skuForm.get(['categoria'])?.disable({
        onlySelf: true,
        emitEvent: false
      })
    }

    this.skuForm.get('nombreInsumo')?.valueChanges.subscribe(() => {
      this.coincidencias = this.data.listaSKU.filter((sku: any) => {
        return (
          stringSimilarity(
            sku.nombreInsumo.toLowerCase(),
            this.skuForm.get(['nombreInsumo'])?.value.toLowerCase()
          ) > 0.5 && sku.id !== this.data.id
        )
      })
    })
  }
  ngOnDestroy (): void {
    this._unsubscribeOnDestroy$.next(true)
    this._unsubscribeOnDestroy$.complete()
  }

  createFoodItemSku () {
    if (
      this.skuForm.get(['nombreInsumo'])?.value &&
      this.skuForm.get(['estado'])?.value &&
      this.skuForm.get(['unidadMedida'])?.value &&
      this.skuForm.get(['peso'])?.value &&
      this.skuForm.get(['categoria'])?.value
    ) {
      Swal.fire({
        title: 'Creando SKU...',
        text: 'Por favor espere',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading()
        }
      })

      this.alimentosService
        .mutationCreateNewFoodItemSku({
          nombreInsumo: this.skuForm.get(['nombreInsumo'])?.value,
          estado: this.skuForm.get(['estado'])?.value,
          categoria: this.skuForm.get(['categoria'])?.value,
          peso: parseFloat(this.skuForm.get(['peso'])?.value),
          unidadMedida: this.skuForm.get(['unidadMedida'])?.value
        })
        .pipe(takeUntil(this._unsubscribeOnDestroy$))
        .subscribe({
          next: createInsumoResponse => {
            console.log({
              createInsumoResponse
            })
            Swal.close()
            this.dialogRef.close(1)
          },
          error: error => {
            console.error(error)
            Swal.fire({
              toast: true,
              position: 'top-end',
              title: 'Error al crear el SKU',
              icon: 'error',
              showConfirmButton: false,
              timer: 3000
            })
          }
        })
    } else {
      Swal.fire({
        toast: true,
        position: 'top-end',
        title: 'Falta ingresar campos requeridos',
        icon: 'warning',
        showConfirmButton: false,
        timer: 3000
      })
    }
  }

  updateFoodItem () {
    console.log({
      skuFormState: this.skuForm.value
    })
    if (
      this.skuForm.get(['nombreInsumo'])?.value &&
      this.skuForm.get(['unidadMedida'])?.value &&
      parseFloat(this.skuForm.get(['peso'])?.value)
    ) {
      Swal.fire({
        title: 'Actualizando SKU...',
        text: 'Por favor espere',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading()
        }
      })

      this.alimentosService
        .mutationUpdateInsumo({
          insumoId: this.data.id,
          updatedInsumo: {
            nombreInsumo: this.skuForm.get(['nombreInsumo'])?.value,
            unidadMedida: this.skuForm.get(['unidadMedida'])?.value,
            peso: parseFloat(this.skuForm.get(['peso'])?.value),
            stock: this.skuForm.get(['stock'])?.value,
            estado: this.skuForm.get(['estado'])?.value
          }
        })
        .pipe(takeUntil(this._unsubscribeOnDestroy$))
        .subscribe({
          next: (data: any) => {
            console.log({
              data
            })
            Swal.close()
            this.dialogRef.close(1)
          },
          error: error => {
            console.error(error)
            Swal.fire({
              toast: true,
              position: 'top-end',
              title: 'Error al actualizar el SKU',
              icon: 'error',
              showConfirmButton: false,
              timer: 3000
            })
          }
        })
    } else {
      Swal.fire({
        toast: true,
        position: 'top-end',
        title: 'Falta ingresar campos requeridos',
        icon: 'warning',
        showConfirmButton: false,
        timer: 3000
      })
    }
  }
}
